import { useTranslation } from 'react-i18next';

export default function ProfilToitures() {
  const { t } = useTranslation('pintendre');

  const profils = [
    {
      icon: 'ri-building-3-line',
      title: t('profil_1_title'),
      desc: t('profil_1_desc'),
    },
    {
      icon: 'ri-hammer-line',
      title: t('profil_2_title'),
      desc: t('profil_2_desc'),
    },
    {
      icon: 'ri-home-smile-line',
      title: t('profil_3_title'),
      desc: t('profil_3_desc'),
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-[#F4F5F7]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('profil_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {profils.map((p, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg p-5 md:p-6 border border-gray-100 hover:border-[#C77D3F]/30 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-[#C77D3F]/10 text-[#C77D3F] mb-4">
                <i className={p.icon} />
              </div>
              <h3 className="text-sm md:text-base font-semibold text-[#1B2A4E] mb-2 uppercase tracking-wide">
                {p.title}
              </h3>
              <p className="text-sm text-[#4A5568] leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}